import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { TableLoaderView } from "../tableLoader";
import { TableModel } from "../../../personal-studio-components/table/TableModel";

function GroupLinkView({ guid, name }) {
  const { menu } = useSelector((state) => state.menu);
  const [data, setData] = useState(null);
  const [table, setTable] = useState(null);

  function rec(arr) {
    for (const obj of arr) {
      if (obj.guid === guid) {
        setData(obj.group);
        break;
      }
      if (obj.child) {
        rec(obj.child);
      }
    }
  }
  useEffect(() => {
    if (menu) {
      rec(menu);
    }
  }, [guid, name, menu]);
  useEffect(() => {
    function createModel() {
      const columns = [{ field: "", type: "link", icon: "copy" }];
      const tableData = new TableModel({ rows: [...data], columns });
      tableData.rows = tableData.rows.filter((row) => row.name);
      tableData.rows = tableData.rows.map((row) => ({
        "": {
          name: row.name,
          href: row.url,
          icon: "copy",
          target: "blank",
        },
      }));
      setTable(tableData);
    }
    if (data) {
      createModel();
    }

    // console.log(guid, name);
  }, [data, guid, name, menu]);
  // console.log("GroupLinkView", table?.rows[0][""].name);

  if (table)
    return (
      <TableLoaderView
        widget={{ title: name, icon: "book_open" }}
        table={table}
      />
    );
}

export default GroupLinkView;
